
import './App.css';
import Footer from './component/footer/footer';
import WbNavbar from './component/header/navbar';
import { Routes, Route , Navigate } from "react-router";
import Home from './home/home';
import Aboutus from './aboutus/aboutus';
import Menu from './menu/menu';
import Contact from './contact/contact';
import FAQ from './faq/faq';
import { BulkOrders } from './bulkorders/bulkorder';
import Blogs  from './blogs/blogs';
import BlogOrganicCakes from "./blogs/blogsPage/blogOrganicCakes";
import PrivacyPolicy from './component/privacy/privacy';
import AOS from "aos";
import 'aos/dist/aos.css';
import { HelmetProvider } from "react-helmet-async";
import WhatsAppButton from './component/whatsup/whatsapp';
import BlogWholeWheatVsMaida from './blogs/blogsPage/blogWholeWheatVsMaida';

import WholeWheatCakes from './wheat-cake/wheat-cake';
import MaidaFreeCakes from './wheat-cake/maida-cake';
import BlogEgglessWholeWheatCakes from './blogs/blogsPage/eggless_whole_wheat_cakes';
import WholeWheatCakesOnlineBlog from './blogs/blogsPage/wholeWheatCakesOnlineBlog';
import BlogMaidaFreeCakes from './blogs/blogsPage/maidaFreeCakes';
import BlogNaturalBirthdayCakesChennai from './blogs/blogsPage/naturalBirthdayCake';
import NaturalBirthdayCakesChennai from './wheat-cake/natural-cake';
import ZeroSugarNaturalCakes from './blogs/blogsPage/blognosugarcakes';
import BlogNaturalBakeryChennai from './blogs/blogsPage/blogNaturalBakery';
import BlogMaidaFreeWholeWheatChennai from "./blogs/blogsPage/maidaFreeWholeCakes";
import BlogWheatCookiesPastries from "./blogs/blogsPage/blogWheatCookiesPastries";
import BlogNaturalVsCommercialCakes from './blogs/blogsPage/blogNaturalVsCommercialCakes';
import BlogWholeWheatMilletRiceBrownies from "./blogs/blogsPage/blogWholeWheatMilletRiceBrownies";
import NaturalBakeryChennai from './wheat-cake/naturalBakeryChennai';
import BlogHomemadeNaturalCakes from './blogs/blogsPage/homemadeStyle';
import BlogGlutenFreeVsWheat from './blogs/blogsPage/blogGlutenFreeWheat';
import BlogVegetarianCakes from "./blogs/blogsPage/blogVegeterianCakes";
import BlogNoArtificialFlavours from "./blogs/blogsPage/blogNoArtificial";
import BlogVegetarianCakesAndDesserts from "./blogs/blogsPage/blogVegeterian";
import BlogNoArtificialFlavoursCakes from "./blogs/blogsPage/blogNoArtificicalCakes";
import BlogWholeWheatNoPreservatives from './blogs/blogsPage/BlogWholeWheatNoPreservatives';
import BlogWholeWheatKids from './blogs/blogsPage/blogWholeWheatKidsCakes';
import BlogNaturalEgglessCakesChennai from "./blogs/blogsPage/blogGainingPopularity";
import BlogWholeWheatCakesOnlineChennai from './blogs/blogsPage/blogWholeWheatCakesOnlineChennai';
import BlogNaturalVsProcessedCakes from './blogs/blogsPage/blogNaturalvsProcessedCakes';


function App() {


  AOS.init(
    {
      offset: 200,
      duration: 600,
      delay: 100,
    }
  );

  return (
    <HelmetProvider>
      <div>
        
        <WbNavbar/>
        
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          
          <Route path="/about-us" element={<Aboutus />} />

          <Route path="/menu" element={<Menu />} />

          {/* <Route path="/gallery" element={<Gallery />} /> */}

          <Route path="/contact" element={<Contact />} />

          <Route path="/faq" element={<FAQ />} />
          <Route path="/whole-wheat-cakes" element={<WholeWheatCakes />} />
          <Route path="/no-preservatives-natural" element={<NaturalBirthdayCakesChennai />} />
          <Route path="/maida-free-cakes" element={<MaidaFreeCakes/>} />   
          <Route path="/natural-bakery-chennai" element={<NaturalBakeryChennai/>} />   

          <Route path="/blogs" exact element={<Blogs />}/>
          <Route path="/blogs/celebrate-healthier-with-clean-ingredients" element={<BlogOrganicCakes/>} />
          <Route path="/blogs/why-whole-wheat-cakes-are-healthier-than-maida-cakes" element={<BlogWholeWheatVsMaida/>}/>
          <Route path="/blogs/eggless-whole-wheat-cakes-a-healthy-choice-for-family" element={<BlogEgglessWholeWheatCakes/> }/>
          <Route path="/blogs/how-to-choose-the-healthiest-option" element={<WholeWheatCakesOnlineBlog/> }/>
          <Route path="/blogs/maida-free-cakes-why-refined-flour-is-best-avoided" element={<BlogMaidaFreeCakes/> }/>
          <Route path="/blogs/natural-birthday-cakes-in-chennai" element={<BlogNaturalBirthdayCakesChennai/> }/>
          <Route path="/blogs/zero-sugar-natural-cakes" element={<ZeroSugarNaturalCakes/> }/>
          <Route path="/blogs/natural-bakery-in-chennai" element={<BlogNaturalBakeryChennai/> }/>
          <Route path="/blogs/maida-free-whole-wheat-cakes-in-chennai" element={<BlogMaidaFreeWholeWheatChennai/> }/>
          <Route path="/blogs/wheat-based-cookies-and-pastries" element={<BlogWheatCookiesPastries/> }/>
          <Route path="/blogs/natural-vs-commercial-bakery-cakes" element={<BlogNaturalVsCommercialCakes/> }/>
          <Route path="/blogs/grain-based-cakes-brownies-chennai" element={<BlogWholeWheatMilletRiceBrownies/> }/>
          <Route path="/blogs/homemade-style-natural-cakes" element={<BlogHomemadeNaturalCakes/> }/>
          <Route path="/blogs/vegetarian-cakes-desserts" element={<BlogVegetarianCakes/> }/>
          <Route path="/blogs/no-artificial-flavours-bakery" element={<BlogNoArtificialFlavours /> }/>
          <Route path="/blogs/vegetarian-cakes-and-desserts" element={<BlogVegetarianCakesAndDesserts/> }/>

          <Route path="/blogs/gluten-free-vs-wheat-brownies-muffins" element={<BlogGlutenFreeVsWheat/> }/>
          <Route path="/blogs/no-artificial-cakes-flavours-bakery" element={<BlogNoArtificialFlavoursCakes /> }/>
          <Route path="/blogs/whole-wheat-cakes-without-preservatives" element={<BlogWholeWheatNoPreservatives /> }/>
          <Route path="/blogs/whole-wheat-cakes-for-kids" element={<BlogWholeWheatKids/>}/>

          <Route path="/blogs/natural-eggless-cakes-chennai" element={<BlogNaturalEgglessCakesChennai/>}/>
          <Route path="/blogs/order-whole-wheat-cakes-online-chennai" element={<BlogWholeWheatCakesOnlineChennai/>}/>
          <Route path="/blogs/natural-ingredient-cakes-vs-processed-cakes" element={<BlogNaturalVsProcessedCakes/>}/>
          
          <Route path="/bulkorders" element={<BulkOrders />} />

          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* 404 Fallback */}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        <WhatsAppButton/>
        <Footer/>
      </div>
    </HelmetProvider>
  );
}

export default App;
